import styled from '@emotion/styled'
import { CategoryCard } from '@hhgtech/hhg-components/components'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { StyledImageIcon } from 'components/pages/healthTools/index.styled'

export const StyledOvulationImageIcon = styled(StyledImageIcon)`
  margin-right: 0.3rem;
  vertical-align: middle;
`

export const StyledMethodContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
`

export const StyledMethodSwitcherContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 0.5rem;
  margin-bottom: 12px;
`

export const StyledMethodCardWrapper = styled.div`
  width: 31%;
  height: 140px;
  ${MediaQueries.mbDown} {
    height: 130px;
    width: 32.5%;
  }
`
export const StyledCategoryCard = styled(CategoryCard)`
  width: 100%;
  height: 100%;
  justify-content: space-around;
  ${MediaQueries.mbDown} {
    padding: 0.25rem;
  }
  &.active {
    border-color: ${theme.colors.primaryBase};
    box-shadow: none;
    p {
      color: ${theme.colors.primaryBase};
    }
  }
`

export const StyledLastPeriodFormContainer = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  .due-date-calculate-button {
    margin-right: auto;
    margin-left: auto;
  }
`
export const StyledInfoContentWrapper = styled.div`
  margin-bottom: 1rem;
  ${MediaQueries.mbUp} {
    padding-left: 1rem;
  }
`

export const StyledFormControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1rem;
`
